import './notFound.css'

export default function NotFound(){
    return window.location='/';
}